<template>
  <div>
  <v-card scrollable>
        <v-card-title class="primary" pt0>
          <h6 class="white--text">Kilometraje</h6>
           <v-btn
                  absolute
                  dark
                  small
                  fab
                  button
                  right
                  class="accent"
                  @click.native="dialog = true"
                >
             +
        </v-btn>
        </v-card-title>
        <v-card-text>
                      <v-container>
            <v-layout>
              <v-flex style="overflow-x: auto" xs12>
                <table class="table">
                  <thead>
                    <th class="pa-0 ma-0"></th>
                    <th class="pa-0 ma-0"></th>
                    <th>Fecha</th>
                    <th>Vehículo</th>
                    <th>Kilometraje Inicial</th>
                    <th v-show="tipo === 'admin'">Kilometraje Final</th>
                    <th>Total Facturas</th>
                    <th>Comentario</th>
                  </thead>
                  <tbody class="ma-0 pa-0">
                    <tr v-for="kilometraje in kilometraje.results">
                      <td class="text-xs-left pa-0">
                        <v-btn icon class="red--text text--darken-2 btn--small" @click="eliminar(kilometraje) " pa-0 ma-0>
                          <v-icon>delete</v-icon>
                        </v-btn></td>
                      <td class="text-xs-left pa-0">
                        <v-btn icon class="blue--text text--darken-2 ">
                          <v-icon>edit</v-icon>
                        </v-btn></td>
                      <td class="text-xs-center text-xs-left pa-0">{{kilometraje.fecha | formatDate2}}</td>
                      <td class="text-xs-center text-xs-left pa-0">{{kilometraje.auto_name}}</td>
                      <td class="text-xs-center text-xs-left pa-0">{{kilometraje.kilometraje_inicial}}</td>
                      <td class="text-xs-center text-xs-left pa-0 ma-0" v-show="tipo=='admin'">{{kilometraje.kilometrage}}</td>
                      <td class="text-xs-center text-xs-left pa-0">{{kilometraje.total_facturas}}</td>
                      <td class="text-xs-center text-xs-left pa-0">{{kilometraje.comentario}}</td>
                    </tr>
                  </tbody>
                </table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent="">
      <v-card>
        <v-card-title primary>
          <span class="headline"> Kilometraje </span>
        </v-card-title>
        <v-card-text>
          <v-text-field label="Kilometraje Inicial:" v-model="akilometraje.kilometraje_inicial"></v-text-field>
          <v-text-field label="Kilometraje:" v-model="akilometraje.kilometraje"></v-text-field>
          <v-text-field label="Total Facturas:" v-model="akilometraje.total_facturas"></v-text-field>
          <v-text-field label="Comentario:" v-model="akilometraje.comentario"></v-text-field>
          <v-select
                  v-bind:items="vehiculos"
                  v-model="vehiculo"
                  itemText="auto_name"
                  :value.sync="vehiculo"
                  label="Vehiculo"
                  single-line
                  bottom
                >
          </v-select>
          <v-dialog
                    persistent
                    v-model="menu"
                    lazy
                    full-width
                  >
                    <v-text-field
                      slot="activator"
                      label="Fecha"
                      v-model="akilometraje.fecha"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="akilometraje.fecha" scrollable>
                      <template slot-scope="{ save, cancel }">
                        <v-card-actions>
                          <v-btn flat primary @click.native="cancel()">Cancelar</v-btn>
                          <v-btn flat primary @click.native="save(), filtrarfechainicio()">Aceptar</v-btn>
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-dialog>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="cerrar">Cerrar</v-btn>
          <v-btn class="blue--text darken-1" flat @click="editarkilometraje">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
 </div>
</template>

<script>
  export default{
    created () {
      this.$store.dispatch('getkilometraje')
    },
    data () {
      return {
        auto_name: ''
      }
    },
    methods: {
      eliminar: function (dato) {
        this.$store.dispatch('eliminarkilometraje', dato)
      },
      filtrarfechainicio: function () {
        console.log(this.fechainicio)
      },
      editarkilometraje: function () {
        let dato = this.$store.getters.akilometraje
        console.log(dato)
        let data = {
          'vehiculo': this.$store.getters.vehiculo.id,
          'fecha': dato.fecha,
          'kilometraje_inicial': dato.kilometraje_inicial,
          'total_facturas': dato.total_facturas,
          'kilometrage': dato.kilometraje, // 'kilometraje': dato.kilometraje,
          'comentario': dato.comentario
        }
        if (dato.kilometraje) {
          data.kilometraje = dato.kilometraje
        }
        this.$store.dispatch('crearkilometraje', data)
        this.$store.commit('actualizardialog', false)
      },
      cerrar: function () {
        this.$store.commit('actualizardialog', false)
      }
    },
    computed: {
      kilometraje () {
        return this.$store.getters.kilometraje
      },
      akilometraje () {
        return this.$store.getters.akilometraje
      },
      dialog: {
        get: function () {
          this.$store.dispatch('getvehiculos')
          return this.$store.getters.dialogo
        },
        set: function (dato) {
          this.$store.commit('actualizardialog', dato)
        }
      },
      vehiculo: {
        get: function () {
          return this.$store.getters.vehiculo
        },
        set: function (dato) {
          this.$store.commit('actualizarvehiculo', dato)
        }
      },
      vehiculos () {
        return this.$store.getters.vehiculos
      },
      tipo () {
        return this.$store.getters.gettipo
      }
    }
  }
</script>




// WEBPACK FOOTER //
// Kilometraje.vue?6ed24f7c